import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-save-status',
  templateUrl: './save-status.component.html',
  standalone: false,
})
export class SaveStatusComponent {
  isSaving = input<boolean>(false);
  lastModified = input<Date | string | number | null>();
  dateFormat = input<string>('yyyy-MM-dd HH:mm');
}
